import React__default from 'react';
import Box from './Box.js';
import Button from './Button.js';
import Illustration from './Illustration.js';
import Typography from './Typography.js';
import 'styled-components';
import './useTheme.js';
import './darken-303c3324.js';
import './_commonjsHelpers-357b3b4e.js';
import './Icon.js';
import './global-2e5d81b9.js';
import './LoadingIndicator.js';
import './core.esm-901288dd.js';
import './inheritsLoose-6f2ea841.js';

const EmptyState = ({
  ctaText,
  descriptionText,
  illustrationName,
  onCtaPress,
  testID,
  titleText
}) => /*#__PURE__*/React__default.createElement(Box, {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  testID: testID
}, illustrationName && /*#__PURE__*/React__default.createElement(Box, {
  marginBottom: "small"
}, /*#__PURE__*/React__default.createElement(Illustration, {
  name: illustrationName,
  width: 280,
  height: 240
})), /*#__PURE__*/React__default.createElement(Box, {
  marginBottom: "xSmall"
}, /*#__PURE__*/React__default.createElement(Typography, {
  variant: "headline-3",
  color: "primary",
  center: true
}, titleText)), /*#__PURE__*/React__default.createElement(Box, {
  marginBottom: "xLarge"
}, /*#__PURE__*/React__default.createElement(Typography, {
  variant: "body-1",
  color: "quaternary",
  center: true
}, descriptionText)), ctaText && onCtaPress && /*#__PURE__*/React__default.createElement(Button, {
  onPress: onCtaPress,
  variant: "primary"
}, ctaText));

export { EmptyState as default };
//# sourceMappingURL=EmptyState.js.map
